import * as Actions from 'store/actions/app/outputs.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_outputs: false,
  outputs: [],
  total_outputs: 0,

  loading_output: false,
  output: null,
}

const outputsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_OUTPUTS: {
      return {
        ...state,
        loading_outputs: action.payload.loading ?? state.loading_outputs,
        outputs: action.payload.items ?? state.outputs,
        total_outputs: action.payload.total ?? state.total_outputs,
      }
    }
    case Actions.GET_OUTPUT_BY_ID: {
      return {
        ...state,
        loading_output: action.payload.loading ?? state.loading_output,
        output: action.payload.data ?? state.output,
      }
    }
    case Actions.RESET_OUTPUT_BY_ID: {
      return { ...state, output: null }
    }
    default: {
      return state
    }
  }
}

export default outputsReducer
